import member from './member';
import ims from '../imports';

export default {
  ...member,
  getMembers: function () {
    return ims.axios({
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + ims.firebase_auth.getAccessToken(),
      },
      baseURL: ims.config.api.prefix,
      url: `/members`,
      responseType: 'json',
      timeout: 1000 * 5,
    });
  },
};
